import CommonHelmet from '@src/components/CommonHelmet';
import LoginForm from '@src/features/company/auth/LoginForm';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyLogin() {
  return (
    <>
      <CompanyCenterCardLayout showCommonComponents>
        <CommonHelmet />
        <LoginForm />
      </CompanyCenterCardLayout>
    </>
  );
}

export default CompanyLogin;
